export function formatPhoneInput(value: string) {
  const trimmed = value.trim();
  const digits = trimmed.replace(/\D/g, "");
  if (!digits) return trimmed;

  const international = trimmed.startsWith("+33") || trimmed.startsWith("0033");
  if (international || (digits.startsWith("33") && digits.length > 10)) {
    const national = digits.startsWith("33") ? digits.slice(2) : digits.startsWith("0033") ? digits.slice(4) : digits;
    const local = national.startsWith("0") ? national.slice(1) : national;
    const grouped = local.slice(0, 9).replace(/(\d{2})(?=\d)/g, "$1 ").trim();
    return grouped ? `+33 ${grouped}` : "+33";
  }

  return digits.slice(0, 10).replace(/(\d{2})(?=\d)/g, "$1 ").trim();
}

export function formatFrenchPhone(value?: string | null) {
  return value ? formatPhoneInput(value) : "—";
}
